import React from "react";

const Community = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clipPath="url(#clip0_11317_15193)">
        <path
          d="M5.92013 17.97L4.56011 17.3C4.37011 17.2 4.2101 17.05 4.1101 16.86C4.0101 16.67 3.98013 16.45 4.01013 16.24L4.5501 13.07C4.6501 12.49 4.96013 11.96 5.42013 11.58C5.88013 11.2 6.46011 10.99 7.06011 10.99H10.9001C11.5001 10.99 12.0801 11.2 12.5401 11.58C13.0001 11.96 13.3001 12.49 13.4001 13.07L13.9401 16.24C13.9901 16.45 13.9601 16.67 13.8601 16.86C13.7601 17.05 13.6001 17.21 13.4001 17.29L12.0501 17.96M6.42014 15.97L6.84012 20.05C6.85012 20.3 6.96013 20.53 7.13013 20.71C7.31013 20.88 7.54011 20.99 7.80011 21H10.0201C10.2701 20.99 10.5101 20.89 10.6901 20.71C10.8701 20.54 10.9701 20.3 10.9801 20.05L11.3901 15.97M15.0401 3C15.7601 3 16.4601 3.28001 16.9701 3.79001C17.4801 4.29001 17.7701 4.98 17.7701 5.69C17.7701 6.4 17.4801 7.08 16.9701 7.59C16.4601 8.09 15.7701 8.38 15.0401 8.38M16.0501 10.98H16.9401C17.5401 10.98 18.1201 11.19 18.5801 11.57C19.0401 11.95 19.3501 12.48 19.4501 13.06L19.9901 16.23C20.0201 16.44 19.9901 16.66 19.8901 16.85C19.7901 17.04 19.6301 17.19 19.4401 17.29L18.0801 17.96M15.0401 20.95H16.1401C16.2701 20.95 16.4001 20.94 16.5201 20.89C16.6401 20.85 16.7501 20.78 16.8501 20.69C16.9401 20.6 17.0201 20.5 17.0701 20.38C17.1201 20.26 17.1501 20.14 17.1501 20.01L17.5701 15.93M8.97012 8.37C10.4801 8.37 11.7001 7.17 11.7001 5.69C11.7001 4.21 10.4801 3.01001 8.97012 3.01001C7.46012 3.01001 6.24011 4.21 6.24011 5.69C6.24011 7.17 7.46012 8.37 8.97012 8.37Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_11317_15193">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Community;
